var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTimelineEmpty = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 64,
    viewBox: "0 0 96 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50:1363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.8157 45.6005C85.1434 57.1864 71.9234 61.3724 62.874 63.0291C51.6606 65.0834 34.7814 64.0121 23.7517 58.5228C14.1645 53.7515 6.16432 45.9097 2.36095 35.3952C-0.66864 27.0232 -0.550598 20.3412 1.40355 13.626C3.37081 6.91076 11.0956 -1.5716 24.5648 0.250786C38.034 2.07317 41.798 10.3236 45.5489 15.8901C50.9261 23.8865 56.7099 25.5212 67.2019 24.251C77.7071 22.9698 85.4844 23.2238 90.9665 26.6477C95.3338 29.3537 98.77 36.6211 92.8157 45.6005Z",
    fill: "#E1E9F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5074 25.8005C11.4447 25.8508 11.4027 25.9207 11.3816 26.01C10.707 29.2074 11.087 31.9193 12.5188 34.0653C14.6628 37.2925 18.3705 38.0391 18.5327 38.0742C18.7395 38.1199 18.9321 37.9807 18.9775 37.7737C19.023 37.5667 18.8837 37.3737 18.6769 37.328C18.6486 37.3249 15.1106 36.597 13.1487 33.642C11.8517 31.677 11.5023 29.1575 12.1314 26.1672C12.1769 25.9602 12.0495 25.7628 11.8427 25.7171C11.7133 25.6971 11.5896 25.7293 11.5074 25.8005Z",
    fill: "#00838F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93313 38.0822C8.9212 38.0866 8.91369 38.103 8.90176 38.1074C8.75379 38.2573 8.76182 38.4988 8.91166 38.6471C11.2157 40.8777 14.2285 41.9087 17.6081 41.6222C20.1446 41.4032 21.9718 40.5502 22.0509 40.5074C22.2329 40.4128 22.3261 40.1882 22.2315 40.0059C22.1368 39.8235 21.9124 39.73 21.7304 39.8246C21.6946 39.8378 19.9151 40.6731 17.5305 40.863C14.3431 41.1192 11.6277 40.1954 9.45274 38.0936C9.30733 37.9573 9.07801 37.9607 8.93313 38.0822Z",
    fill: "#00838F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8679 51.9038C59.9191 51.9252 59.959 51.9313 60.0123 51.9394C63.3084 52.4809 66.6367 52.1828 69.6389 51.0722C78.6802 47.6914 81.767 38.3112 82.2919 36.4701C82.4587 35.9097 82.1402 35.3164 81.5911 35.1649C81.0419 35.0134 80.462 35.3339 80.2931 35.9077C79.8211 37.5797 77.0336 46.0654 68.948 49.0737C66.2917 50.0597 63.3217 50.3306 60.3718 49.8416C59.8013 49.7413 59.2645 50.1366 59.1621 50.7204C59.0833 51.2397 59.3873 51.7491 59.8679 51.9038Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6721 36.3352C81.6721 36.3352 78.0249 33.7105 77.1225 35.1673C76.2068 36.622 79.5857 37.0671 81.6721 36.3352Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1957 36.3309C81.1957 36.3309 83.6257 31.0058 81.9729 30.9455C80.3222 30.8718 80.2178 34.6975 81.1957 36.3309Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3188 36.4177C81.3188 36.4177 86.3942 33.497 85.0908 32.4816C83.7721 31.4776 81.4689 34.5333 81.3188 36.4177Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2034 36.3729C81.2034 36.3729 86.8961 37.7281 86.64 36.0954C86.384 34.4626 82.6089 35.1016 81.2034 36.3729Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9188 37.0709C32.8794 37.0726 32.8239 37.0671 32.7845 37.0688C29.7124 36.6816 26.844 35.5355 24.4765 33.7438C17.3535 28.3502 17.1013 19.2072 17.1306 17.4336C17.1344 16.8848 17.5694 16.4513 18.1066 16.4595C18.6438 16.4677 19.0656 16.9072 19.0502 17.4605C19.0257 19.0721 19.2473 27.3322 25.6149 32.1469C27.7168 33.733 30.272 34.7585 33.0183 35.0968C33.55 35.1605 33.9269 35.6572 33.8516 36.1934C33.8023 36.6929 33.396 37.0619 32.9188 37.0709Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7089 17.4795C17.7089 17.4795 21.6322 16.1125 22.0582 17.6453C22.4841 19.178 19.3719 18.686 17.7089 17.4795Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1402 17.5949C18.1402 17.5949 17.3974 12.2312 18.8785 12.6128C20.3551 12.9827 19.4345 16.4056 18.1402 17.5949Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0004 17.6484C18.0004 17.6484 14.2688 13.7214 15.6971 13.1619C17.1253 12.6023 18.3716 15.9309 18.0004 17.6484Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1025 17.636C18.1025 17.636 12.6969 17.3267 13.355 15.9402C14.013 14.5536 17.2037 16.1238 18.1025 17.636Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 10.6,
    width: 40,
    height: 47,
    rx: 3,
    fill: "white",
    stroke: "#00838F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_50:1363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.3186 8.59854H51.6896V7.8896C51.6896 5.74361 50.0538 4 48.0404 4H47.9685C45.9462 4 44.3103 5.74361 44.3103 7.8896V8.59854H39.6814C39.4477 8.59854 39.25 8.80931 39.25 9.05839V14.0306C39.25 14.2892 39.4477 14.4904 39.6814 14.4904H56.3186C56.5612 14.4904 56.75 14.2797 56.75 14.0306V9.05839C56.75 8.80931 56.5612 8.59854 56.3186 8.59854Z",
    fill: "#193E6D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.7423 36.5359C55.2715 34.9723 56.1574 33.3232 57.7209 32.8524C59.2845 32.3816 60.9336 33.2675 61.4044 34.8311C61.8752 36.3946 60.9893 38.0438 59.4258 38.5145C57.8622 38.9853 56.2131 38.0994 55.7423 36.5359Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4432 34.9539C58.5495 35.5069 59.06 35.8686 59.6131 35.7622C60.1661 35.6558 60.5277 35.1453 60.4214 34.5923C60.315 34.0392 59.8045 33.6776 59.2515 33.784C58.7197 33.8903 58.3368 34.4221 58.4432 34.9539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4536 38.482C33.8777 38.054 32.9471 36.4295 33.375 34.8535C33.803 33.2776 35.4276 32.347 37.0035 32.775C38.5795 33.203 39.5101 34.8275 39.0821 36.4035C38.6541 37.9794 37.0296 38.91 35.4536 38.482Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1044 34.9248C36.2108 35.4778 36.7213 35.8395 37.2743 35.7331C37.8274 35.6267 38.189 35.1162 38.0826 34.5632C37.9763 34.0101 37.4658 33.6485 36.9127 33.7549C36.3809 33.84 36.0193 34.3717 36.1044 34.9248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.595 41.8458C47.063 41.8458 47.5735 41.782 48.1266 41.6543C51.1046 40.9098 51.9554 38.3147 51.9767 37.0385C51.9767 36.6556 51.6789 36.3578 51.3173 36.3365C51.3173 36.3365 51.3173 36.3365 51.296 36.3365C50.9344 36.3365 50.6366 36.6343 50.6153 36.9959C50.6153 37.1023 50.509 39.6548 47.7862 40.3355C44.4254 41.1651 43.2767 38.4211 43.2129 38.2935C43.064 37.9531 42.6811 37.783 42.3408 37.9106C42.0004 38.0595 41.8303 38.4424 41.9579 38.7827C42.4471 39.9739 43.9361 41.8458 46.595 41.8458Z",
    fill: "#363437"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 55,
    r: 4,
    fill: "#193E6D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 61.5,
    r: 1.5,
    fill: "#193E6D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 60,
    r: 4,
    fill: "#E1E9F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50:1363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 64,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_50:1363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 10.5,
    fill: "white",
    transform: "translate(39.25 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTimelineEmpty, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/timeline-empty.1a0d0e83.svg";
export { ForwardRef as ReactComponent };